import { useCurrentFrame, useVideoConfig, interpolate } from 'remotion';

export default function SubtitleOverlay({ text }) {
  const frame = useCurrentFrame();
  const { durationInFrames } = useVideoConfig();

  const fadeFrames = 12;
  const opacity = interpolate(
    frame,
    [0, fadeFrames, durationInFrames - fadeFrames, durationInFrames],
    [0, 1, 1, 0],
    { extrapolateLeft: 'clamp', extrapolateRight: 'clamp' }
  );

  // Slide up entrance
  const translateY = interpolate(
    frame, [0, fadeFrames], [8, 0],
    { extrapolateRight: 'clamp' }
  );

  return (
    <div style={{
      position: 'absolute', bottom: 48, left: 0, right: 0,
      display: 'flex', justifyContent: 'center',
      pointerEvents: 'none', zIndex: 100,
      opacity,
      transform: `translateY(${translateY}px)`,
    }}>
      <div style={{
        background: 'rgba(0, 0, 0, 0.82)',
        color: '#fff',
        padding: '12px 32px',
        borderRadius: 8,
        fontSize: 28,
        fontWeight: 500,
        fontFamily: "'Segoe UI', 'Roboto', sans-serif",
        maxWidth: '75%',
        textAlign: 'center',
        lineHeight: 1.5,
        letterSpacing: '0.2px',
        textShadow: '0 1px 3px rgba(0,0,0,0.5)',
        backdropFilter: 'blur(4px)',
        border: '1px solid rgba(255,255,255,0.08)',
      }}>
        {text}
      </div>
    </div>
  );
}
